<template>
  <div @touchmove="preLoad(getPre)">
    <classify :category-list="indexCategoryList" :type="2"></classify>
    <zone-list :list="list"></zone-list>
    <p
      style="text-align:center;margin-top: 1rem"
      v-show="!list.length && isData"
    >
      <inline-loading></inline-loading>
      <span style="vertical-align:middle;display:inline-block;font-size:14px;">
        &nbsp;&nbsp;加载中
      </span>
    </p>
    <p style="text-align: center;margin-top: 1rem" v-show="!isData">
      暂无内容，换个学科试试！
    </p>
  </div>
</template>
<script>
import Classify from '@/components/Classify.vue';
import ZoneList from '@/components/Zone/ZoneList.vue';
import { mapState } from 'vuex';
import { zone } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';

export default {
  name: '',
  mixins: [loadMore],
  data() {
    return {
      list: [],
      params: {
        pageNo: 1,
        pageSize: 20
      },
      loadFlag: true,
      indexCategoryList: [],
      isData: true, // 加载各类一级学科后是否有数据
      timer: null
    };
  },
  methods: {
    info() {
      //初始化滑动
      this.list = [];
      this.params.pageNo = 1;
      this.loadFlag = true;
      this.isData = true;
    },
    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        zone.doList(data).then(res => {
          let resp = res.data.data.list;
          if (resp.length == 0) {
            this.loadFlag = false;
            this.timer = setTimeout(() => {
              this.isData = false;
              clearTimeout(this.timer);
              this.timer = null;
            }, 1500);
          } else {
            for (let i = 0; i < resp.length; i++) {
              if (this.$api.isKln()) {
                //kln中把外部链接的去掉
                if (!resp[i].externalLink) {
                  this.list.push(resp[i]);
                }
              } else {
                this.list.push(resp[i]);
              }
            }
            if (resp.length < this.params.pageSize) {
              this.loadFlag = false;
              return false;
            }
            this.params.pageNo++;
            this.loadFlag = true;
          }
        });
      }
    },
    getPre() {
      this.getList(
        Object.assign(this.params, {
          categoryId: this.classifyId.id == '全部' ? '' : this.classifyId.id
        })
      );
    },
    indexCategory() {
      zone.category().then(res => {
        this.indexCategoryList = res.data.data;
      });
    }
  },
  computed: {
    ...mapState({
      classifyId: state => state.classifyId
    })
  },
  watch: {
    classifyId(val) {
      this.info();
      this.getList(
        Object.assign(this.params, {
          categoryId: val.id == '全部' ? '' : val.id
        })
      );
    },
    indexCategoryList(val) {}
  },
  components: {
    ZoneList,
    Classify
  },
  created() {
    this.indexCategory();
    this.getPre();
  },
  beforeDestroy() {}
};
</script>
